import React, { FunctionComponent as FC, ReactNode, createContext, useState, useEffect } from 'react';
import { PietroskiFormBox } from './styled';
import Item, { ItemProps } from './item';
import Button, { ButtonProps } from './button'

interface FormComposition {
    Item: FC<ItemProps>
    Button: FC<ButtonProps>
}

export interface FormProps {
    darkMode?: boolean;
    formTitle?: String;
    onSubmit?: (data: any) => void;
    children?: ReactNode | FormComposition | any;
    width?: string;
    minHeight?: string;
    margin?: string;
    titleFontSize?: string;
    validations?: any;
    errors?: any;
}

export const FormPropsContext = createContext<Partial<FormProps>>({});
export const FieldsContext = createContext({});
export const ValidationsContext = createContext({});
export const OnSubmitContext = createContext(() => {});

const Form: FC<FormProps | FormComposition> & FormComposition = (props: FormProps) => {

    const ws = useWindowSize().width;

    const {
        width = ws >= 500 ? "450px" : "90vw",
        titleFontSize = ws >= 365 ? "4rem" : 
                        ws < 365 && ws >= 285 ? "3.5rem" : 
                        ws < 285 && ws >= 235 ? "3rem" : 
                        ws < 235 && ws >= 190 ? "2.5rem" : "2rem",
        formTitle = "Register",
        children
    } = props;

    const treatedChildrenKeys = children?.map((e: any) => e?.props?.inputLabel && [e?.props?.inputLabel, e?.props?.inputType])?.filter((e: any) => e);
    const fields: any = treatedChildrenKeys?.reduce((acc: any, cv: any) => Object.assign(acc, {[cv[0]]: {[cv[0]]: "", inputType: cv[1]}}), {});

    const errors: any = treatedChildrenKeys?.reduce((acc: any, cv: any) => Object.assign(acc, {[cv[0]]: "This field cannot be blank"}), {});

    const [fieldValues, setFieldValues] = useState<any>({...fields});
    const [fieldErrors, setFieldErrors] = useState<any>({...errors});

    const checkValidity: any = () => {
      Object.values(fieldValues).forEach((e: any) => {
        treatedChildrenKeys.forEach((i: any) => {
          (e[i[0]] !== undefined) ? e[i[0]] === "" ? setFieldErrors({ ...fieldErrors, [i[0]]: "This field cannot be blank"}) : setFieldErrors({ ...fieldErrors, [i[0]]: "This field cannot be blank"}) : ("out") 
        })
      });
    }

    useEffect(() => {
      checkValidity();
    }, [fieldValues]);

    const onSubmit = () => props.onSubmit && props.onSubmit(fieldValues)

    return (
        <FieldsContext.Provider value={[fieldValues, setFieldValues]} >
          <ValidationsContext.Provider value={[fieldErrors, setFieldErrors]} >
            <OnSubmitContext.Provider value={onSubmit} >
              <FormPropsContext.Provider value={props} >
                <PietroskiFormBox {...props} width={width} titleFontSize={titleFontSize} >
                  <h1>{formTitle}</h1>
                  {children}
                </PietroskiFormBox>
              </FormPropsContext.Provider>
            </OnSubmitContext.Provider>
          </ValidationsContext.Provider>
        </FieldsContext.Provider>
    )
}

Form.Item = Item;
Form.Button = Button;

export default Form;

type Measures = {
  width: number,
  height: number
}

function useWindowSize(): Measures {

  const [windowSize, setWindowSize] = useState<Measures>({
      width: 0,
      height: 0,
  });

  useEffect(() => {  
    function handleResize(): void {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);

  }, []);

  return windowSize;
}